// WhiteSpace CRUD
export const GET_BOARD_WHITE_SPACES = "WhiteSpace/GET_BOARD_WHITE_SPACES";
export const GET_WHITE_SPACE_BY_ID = "WhiteSpace/GET_WHITE_SPACE_BY_ID";
export const CREATE_WHITE_SPACE = "WhiteSpace/CREATE_WHITE_SPACE";
export const UPDATE_WHITE_SPACE = "WhiteSpace/UPDATE_WHITE_SPACE";
export const SET_WHITE_SPACE_ARCHIVE = "WhiteSpace/SET_WHITE_SPACE_ARCHIVE";
export const DELETE_WHITE_SPACE = "WhiteSpace/DELETE_WHITE_SPACE";

// Task / TaskMap WhiteSpace CRUD
export const CREATE_TASK_WHITE_SPACE = "WhiteSpace/CREATE_TASK_WHITE_SPACE";
export const CREATE_TASK_MAP_WHITE_SPACE =
  "WhiteSpace/CREATE_TASK_MAP_WHITE_SPACE";
export const UPDATE_TASK_WHITE_SPACE = "WhiteSpace/UPDATE_TASK_WHITE_SPACE";
export const UPDATE_TASK_MAP_WHITE_SPACE =
  "WhiteSpace/UPDATE_TASK_MAP_WHITE_SPACE";
export const DELETE_TASK_WHITE_SPACE = "WhiteSpace/DELETE_TASK_WHITE_SPACE";
export const DELETE_TASK_MAP_WHITE_SPACE =
  "WhiteSpace/DELETE_TASK_MAP_WHITE_SPACE";

// Loading & error states
export const SET_WHITE_SPACES_LOADING = "WhiteSpace/SET_WHITE_SPACES_LOADING";
export const SET_WHITE_SPACES_ERROR = "WhiteSpace/SET_WHITE_SPACES_ERROR";
export const CLEAR_WHITE_SPACE_STATE = "WhiteSpace/CLEAR_WHITE_SPACE_STATE";
export const CLEAR_CURRENT_WHITE_SPACE = "WhiteSpace/CLEAR_CURRENT_WHITE_SPACE";

// Section categories (Board.SectionCategories.WhiteSpaces)
export const GET_WHITE_SPACE_CATEGORIES =
  "WhiteSpace/GET_WHITE_SPACE_CATEGORIES";
export const SET_WHITE_SPACE_CATEGORIES_LOADING =
  "WhiteSpace/SET_WHITE_SPACE_CATEGORIES_LOADING";
export const SET_WHITE_SPACE_CATEGORIES_ERROR =
  "WhiteSpace/SET_WHITE_SPACE_CATEGORIES_ERROR";
